import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/tx_PurchasePlans/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/tx_PurchasePlans/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/tx_PurchasePlans/Add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/tx_PurchasePlans/Update',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/tx_PurchasePlans/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/tx_PurchasePlans/Get',
    method: 'get',
    params: { id: id }
  });
}

export function Commit(paramStr) {
  return request({
    url: '/tx_PurchasePlans/Commit',
    method: 'post',
    data: { paramStr }
  });
}

export function Cancel(paramStr) {
  return request({
    url: '/tx_PurchasePlans/Cancel',
    method: 'post',
    data: { paramStr }
  });
}

export function Delete(paramStr) {
  return request({
    url: '/tx_PurchasePlans/Delete',
    method: 'post',
    data: { paramStr }
  });
}

export function getloadfile(data) {
  return request({
    url: '/tx_PurchasePlans/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}
